module.exports = __webpack_public_path__ + "static/media/vivi-andando-2.26017d15.svg";